<template>
  <!--待评标-->
  <div class="friend-circle">
    <van-form>
      <div class="basic failed" v-if="isUpdate">
        <div class="title">
          <van-icon name="failure"/>
          审核不通过
        </div>
        <div class="content">{{ friendCircle.examineReason }}</div>
      </div>

      <div class="basic">
        <van-field
          v-model="content"
          rows="4"
          autosize
          label=""
          type="textarea"
          placeholder="输入此时的想法..."
          maxlength="200"
          show-word-limit
        />
      </div>

      <div class="basic file-content">
        <div class="fileBox">
          <img src="../../assets/images/publicImg/btn_pic_upload.png" class="btn_pic_upload" @click="upload">
          <div v-for="(item, index) in attachs" :key="index"
               @click="attDetail(item, index)">
            <div style="position: relative">
              <img :src="item.attachUrl"
                   v-if="item.fileType ==='jpg' || item.fileType ==='png' || item.fileType ==='jpeg'">
              <div v-if="item.fileType ==='mp4'" class="videoBox">
                <video :poster="item.attachUrl+'?x-oss-process=video/snapshot,t_1,m_fast'" :src="item.attachUrl" class="video"></video>
                <img src="../../assets/images/publicImg/icon_video_bg.png" class="icon_video_bg">
              </div>
              <van-icon class="icon-attachDelete" name="clear" @click.stop="attachDelete(index)"/>
            </div>
          </div>
        </div>
      </div>

      <div class="visible">
        <van-cell title="谁可以看" :value="visibleText" @click="showPicker = true" is-link/>
      </div>

      <div class="bottom-btn" v-if="isUpdate">
        <van-button class="van-button-1" color="#E83B3BFF" round @click="deleteById" plain block>删除</van-button>
        <van-button class="van-button-2" color="#096CEFFF" round @click="onSubmit" block>重新发布</van-button>
      </div>

      <div class="bottom-btn" v-else>
        <van-button round block color="#096CEF" type="info" @click="onSubmit">立即发布</van-button>
      </div>
    </van-form>

    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        title="谁可以看"
        show-toolbar
        :columns="typeList"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>

    <van-dialog
      style="width:100%;border-radius:0;height:200px"
      theme="default"
      v-model="showvideoplay"
      :show-cancel-button="false"
      :show-confirm-button="false"
      closeOnClickOverlay
    >

      <div ref="videobox" id="mui-player"></div>
    </van-dialog>
    <div id="video-ios" style="height: 0"></div>
  </div>
</template>

<script>
import { pubFriendCircle, deleteFriendCircle, detail, republish } from '@api/friendCircle'
import 'mui-player/dist/mui-player.min.css'
import MuiPlayer from 'mui-player'
import { ImagePreview } from 'vant'

export default {
  name: 'friend-circle',
  data () {
    return {
      city: '320500',
      content: '',
      attachs: [],
      visible: 1,
      visibleText: '公开',
      typeList: [{ id: 1, text: '公开' }, { id: 2, text: '仅工友可见' }],
      showPicker: false,
      isUpdate: false,
      friendCircle: {},
      videourl: '',
      showvideoplay: false,
    }
  },
  created () {
    if (this.$route.query.id) {
      this.id = this.$route.query.id
      this.isUpdate = true
      this.findById()
    }
    // 初始化极光统计
    this.$jiguang.initCountEvent()

    if (this.$route.query.cityId) {
      this.city = this.$route.query.cityId
    } else {
      let cityId = localStorage.getItem('cityId')
      if (cityId && cityId !== 'undefined') {
        this.city = cityId
      }
    }

    // 客户端调起图片上传后
    this.$bridge.registerHandler('decodeMethod', (data, responseCallback) => {
      this.decodeMethod(data)
      responseCallback(data)
    })
  },
  methods: {

    // 根据id获取详情
    findById () {
      detail({ friendCircleId: this.id }).then(res => {
        if (res.data.code === 200) {
          let friendCircle = res.data.data
          this.friendCircle = friendCircle
          this.content = friendCircle.content
          this.visible = friendCircle.visible
          if (friendCircle.visible == 1) {
            this.visibleText = '公开'
          } else if (friendCircle.visible == 2) {
            this.visibleText = '仅工友可见'
          }
          if (friendCircle.fileUrl && friendCircle.fileUrl.length > 0) {
            for (let i = 0; i < friendCircle.fileUrl.length; i++) {
              this.attachs.push({
                attachName: '',
                attachUrl: friendCircle.fileUrl[i],
                fileType: friendCircle.fileUrl[i].substring(friendCircle.fileUrl[i].lastIndexOf('.') + 1) // 文件后缀名
              })
            }
          }
          this.city = friendCircle.city
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 根据id删除朋友圈信息
    deleteById () {
      this.$dialog.confirm({
        title: '提示',
        message: '确定删除该朋友圈？',
      })
        .then(() => {
          // 获取极光统计所需数据
          this.$bridge.callHandler('getDeviceInfo', 'h5_delete_friend_circle', response => {
            console.log('response:', response)
          })
          deleteFriendCircle(this.id).then(res => {
            if (res.data.code === 200) {
              setTimeout(() => {
                this.$bridge.callHandler('backRefresh', response => {
                  console.log('response:', response)
                })
              }, 1000)
            } else {
              this.$toastMsg(res.data.msg)
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    },

    // 上传图片
    upload () {
      if (this.attachs.length >= 9) {
        this.$toastMsg('最多上传9个')
        return
      }
      const data = {
        bucket: 'yiyong-pub',
        path: 'friendCircle/',
        type: 0 // 0-不上传文件，1-上传文件
      }
      this.$bridge.callHandler('uploadMethod', data, response => {
        console.log('response:', response)
      })
    },

    // 解密
    decodeMethod (data) {
      this.attachs.push({
        attachName: (decodeURIComponent(data)).substring(data.lastIndexOf('/') + 1),
        attachUrl: data,
        fileType: data.substring(data.lastIndexOf('.') + 1) // 文件后缀名
      })
    },

    // 下载附件
    attDetail (file, index) {

      if (file.fileType === 'mp4') {
        // 判断ios还是安卓
        const u = navigator.userAgent
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
        if (isiOS) {

          const video = document.getElementById('playVideos')
          if (video) {
            video.remove()
          }

          let str = document.createElement('video')
          str.id = 'playVideos'
          str.src = file.attachUrl
          str.setAttribute('controls', 'controls')
          str.style.width = '0'
          str.style.height = '0'
          str.play()
          document.getElementById('video-ios').append(str)

        } else {
          this.$bridge.callHandler('newPage', { url: file.attachUrl }, response => {
            console.log('response:', response)
          })
          return
          this.showvideoplay = true

          setTimeout(function () {
            // 初始化 MuiPlayer 插件，MuiPlayer 方法传递一个对象，该对象包括所有插件的配置
            var mp = new MuiPlayer({
              container: '#mui-player',
              title: '视频',
              src: file.attachUrl,
              preload: 'auto',
              autoplay: true
            })
          }, 500)
        }
      } else {
        let list = []
        for (let i = 0; i < this.attachs.length; i++) {
          if (this.attachs[i].fileType !== 'mp4') {
            list.push(this.attachs[i].attachUrl)
          } else {
            if (i <= index) {
              index = index - 1
            }
          }
        }

        ImagePreview({
          images: list,
          showIndex: true,
          loop: false,
          startPosition: index
        })
      }
    }
    ,

    attachDelete (index) {
      this.attachs.splice(index, 1)
    }
    ,

    onConfirm (value) {
      this.visible = value.id
      this.visibleText = value.text
      this.showPicker = false
    }
    ,

    // 弹窗取消
    onCancel () {
      this.showPicker = false
    }
    ,

    // 发布
    onSubmit () {
      if (!this.content && this.attachs.length == 0) {
        this.$toastMsg('请填写内容或上传图片')
        return
      }
      let fileUrl = []
      for (let i = 0; i < this.attachs.length; i++) {
        fileUrl.push(this.attachs[i].attachUrl)
      }
      // 获取极光统计所需数据
      this.$bridge.callHandler('getDeviceInfo', 'h5_pub_friend_circle', response => {
        console.log('response:', response)
      })

      // isUpdate 重新发布
      if (this.isUpdate) {
        republish({
          friendCircleId: this.friendCircle.id,
          city: this.city,
          content: this.content,
          fileUrl: fileUrl,
          visible: this.visible,
          type: 0,
        }).then(res => {
          if (res.data.code === 200) {
            this.$toast.success('发布成功')
            setTimeout(() => {
              this.$bridge.callHandler('backRefresh', response => {
                console.log('response:', response)
              })
            }, 1000)
          } else {
            this.$toastMsg(res.data.msg)
          }
        })
      } else {
        pubFriendCircle({
          city: this.city,
          content: this.content,
          fileUrl: fileUrl,
          visible: this.visible,
          type: 0,
        }).then(res => {
          if (res.data.code === 200) {
            this.$toast.success('发布成功')
            setTimeout(() => {
              this.$bridge.callHandler('backRefresh', response => {
                console.log('response:', response)
              })
            }, 1000)
          } else {
            this.$toastMsg(res.data.msg)
          }
        })
      }
    }
    ,
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/mixin";

.van-button--default {
  background-color: #fff;
}

#mui-player {
  height: 200px !important;
}

.friend-circle {
  padding-top: 10px;
  padding-bottom: 50px;

  .failed {
    border: 1px solid rgba(242, 54, 54, 0.5);
    background-color: #F236360D;

    padding: 10px;

    .title {
      color: #F23636FF;
      @include add_size($font_size_20);
      font-size: 18px;
      padding-bottom: 5px;

      .van-icon {
        @include add_size($font_size_20);
        vertical-align: -15%;
      }
    }

    .content {
      @include add_size($font_size_16);
    }
  }
}

.file-content {
}

.visible {
  .van-cell {
    padding: 10px;
    display: flex;
    color: #333;
  }
}

.van-cell:not(:last-child)::after {
  display: none;
}

.van-field__control {
  @include add_size($font_size_16);
}

.van-cell__value {
  text-align: right;
}

.van-field__label {
  @include add_size($font_size_16);
  width: 20%;
}

.fileBox {
  display: flex;
  flex-wrap: wrap;

  img {
    width: 80px;
    height: 80px;
    margin-top: 10px;
    margin-left: 10px;
    flex-shrink: 0;
  }

  .videoBox {
    width: 80px;
    height: 80px;
    margin-top: 10px;
    margin-left: 10px;
  }

  .icon_video_bg {
    width: 80px;
    height: 80px;
    position: absolute;
    top: -10px;
    left: 0;
    z-index: 0;
  }

  .video {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }

  .icon-attachDelete {
    position: absolute;
    top: -10px;
    right: -10px;
  }
}

</style>
